import { FILE_TYPE } from "../file-upload/uploadFileConsts";

export const DEFAULT_IMAGE_TYPES = [FILE_TYPE.JPEG, FILE_TYPE.JPG, FILE_TYPE.PNG, FILE_TYPE.SVG];